import { Fragment } from 'react';
import { parseMarkdown, type Inline } from './markdown.js';

/** Renders Alfred's reply text safely (see markdown.ts). */
export function Rich({ text }: { text: string }) {
  return (
    <>
      {parseMarkdown(text).map((block, i) => {
        if (block.type === 'heading') {
          return (
            <p key={i} className="rich-heading">
              <Inlines items={block.content} />
            </p>
          );
        }
        if (block.type === 'list') {
          const Tag = block.ordered ? 'ol' : 'ul';
          return (
            <Tag key={i}>
              {block.items.map((item, j) => (
                <li key={j}>
                  <Inlines items={item} />
                </li>
              ))}
            </Tag>
          );
        }
        return (
          <p key={i}>
            {block.lines.map((line, j) => (
              <Fragment key={j}>
                {j > 0 && <br />}
                <Inlines items={line} />
              </Fragment>
            ))}
          </p>
        );
      })}
    </>
  );
}

function Inlines({ items }: { items: Inline[] }) {
  return (
    <>
      {items.map((it, i) => {
        switch (it.type) {
          case 'bold':
            return <strong key={i}>{it.text}</strong>;
          case 'code':
            return <code key={i}>{it.text}</code>;
          case 'link':
            return (
              <a key={i} href={it.href} target="_blank" rel="noopener noreferrer">
                {it.text}
              </a>
            );
          default:
            return <Fragment key={i}>{it.text}</Fragment>;
        }
      })}
    </>
  );
}
